import { selectInvitesHistory } from '@src/features/shift-post-v2/state/shift-post-v2.selectors'
import { ROSTER_INVITE_STATUS } from '@network/models/roster.model'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useInvitesHistory = () => {
  const invitesHistory = useSelector(selectInvitesHistory)

  const pendingRosterIds = useMemo(() => {
    const ids =
      invitesHistory
        ?.filter(invite => invite.status === ROSTER_INVITE_STATUS.PENDING)
        .flatMap(
          invite => invite?.rosters?.data?.map(roster => roster.id) ?? [],
        ) ?? []
    return new Set(ids)
  }, [invitesHistory])

  const finishedRosterIds = useMemo(() => {
    const ids =
      invitesHistory
        ?.filter(invite => invite.status === ROSTER_INVITE_STATUS.FINISHED)
        .flatMap(
          invite => invite?.rosters?.data?.map(roster => roster.id) ?? [],
        ) ?? []
    return new Set(ids)
  }, [invitesHistory])

  const getBadgeProps = (isFinished: boolean, isPending: boolean) => {
    if (isPending) {
      return {
        text: 'Invitation in Progress',
        type: 'primary' as const,
      }
    }

    if (isFinished) {
      return {
        text: 'Invited Before',
        type: 'warning_300' as const,
      }
    }

    return undefined
  }

  return { pendingRosterIds, finishedRosterIds, invitesHistory, getBadgeProps }
}
